import React from "react"
import {jsPDF} from "jspdf"
import autoTable from "jspdf-autotable"
import JsBarcode from "jsbarcode"

export function impresionrecibopago(nombreempresa,nombrereporte,data,cedula,nombres,noprest,nosolic,pendpago,atraso, capital, interesPendiente, moraPendiente, totalCargos = 0, tipoPrestamo = 'fija') {
   
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [77,355]
     })

     var fontSize = 10
     console.log(data)
     //text width
//     doc.addImage(process.env.REACT_APP_SERVIDOR+"/logo"+'/'+localStorage.getItem('parent'),'JPEG',35,10,12,12)

     doc.setFont("helvetica","bold")
     doc.setFontSize(10)
     var xcenter = doc.internal.pageSize.width/2
     doc.text(nombreempresa,xcenter,27,{align:'center'})
     
     doc.setFont("helvetica","bold")
     doc.text(nombrereporte,xcenter,32,{align: 'center'})
    
     
     doc.setFont("helvetica","normal")
     doc.setFontSize(5)
     
     doc.text("____________________________________________________________________________",1,35)
  
     doc.setFontSize(8)
     
     
     doc.setFont("helvetica","bold")
     doc.text("Cedula",4,40)
     doc.setFont("helvetica","normal")
     doc.text(cedula,20,40)
     
     doc.setFont("helvetica","bold")
     doc.text("Nombres",4,44)
     doc.setFont("helvetica","normal")
     doc.text(nombres,20,44)
     
     doc.setFont("helvetica","bold")
     doc.text("Noprest",4,48)
     doc.setFont("helvetica","normal")
     
     doc.text(noprest,20,48)
     
     doc.setFont("helvetica","bold")
     doc.text("Fecha",4,52)
     doc.setFont("helvetica","normal")
     // Insert current date in format dd/mm/yyyy
     const now = new Date();
     const day = String(now.getDate()).padStart(2, '0');
     const month = String(now.getMonth() + 1).padStart(2, '0');
     const year = now.getFullYear();
     doc.text(`${day}/${month}/${year}`, 20, 52);
     
     doc.setFont("helvetica","normal")
     
     const datalist = []
     var c = 0
     var totalpagado = 0
     var totalmora = 0
     var totaldescuento = 0
     var totalpendiente = 0
     data.map((result)=>{
        if (parseFloat(result['cuotapagado']) != 0) {
           datalist[c] = [result['nocuota'],result['cuotapagado'],result['morapagado'],result['pendiente']]
           c++
           totalpagado = totalpagado + parseFloat(result['cuotapagado'])
           totalmora = totalmora + parseFloat(result['morapagado'])
           totalpendiente = totalpendiente + parseFloat(result['pendiente'])
        }
        else if(parseFloat(result['morapagado']) != 0){
          datalist[c] = [result['nocuota'],result['cuotapagado'],result['morapagado'],result['pendiente']]
          c++
          totalmora = totalmora + parseFloat(result['morapagado'])
        }
        
      })
  
     var finalY = 0
     autoTable(doc,{
        head:[['  #Cuota','  Pagado','Mora','        Balance']],
        body: datalist,
        startY: 56,
        margin: {left: 0, right:0},
        styles: { fontSize: 8},
        columnStyles: {
            0: {width:100, halign:"center"},
            1: {halign:"center",width:100}, 
            2: {halign:"center",width:100},
            3: {halign:"center",width:100}
        },
        headStyles: {fillColor:"#18586b"},
        alternateRowStyles: {fillColor:"white"},
        didDrawPage: function(data){
            finalY = data.cursor.y
        }
     })
 
     
     doc.setFontSize(5)
     finalY = finalY + 15
     
     doc.text("____________________________________________________________________________",1,finalY)
     doc.setFontSize(8)

     finalY = finalY + 8

     const cargosNum = parseFloat(totalCargos) || 0;

     if(pendpago != "reimpresion"){
      const capitalPendienteNum = parseFloat(pendpago) || 0;
      const interesPendienteNum = parseFloat(interesPendiente) || 0;
      const moraPendienteNum = parseFloat(moraPendiente) || 0;
      const capitalPagadoNum = parseFloat(capital) || 0;
      const totalPendienteAntes = capitalPendienteNum + interesPendienteNum + moraPendienteNum;
      const totalPagadoAhora = totalpagado + totalmora + capitalPagadoNum;
      const balancePendiente = Math.max(totalPendienteAntes - totalPagadoAhora, 0);
      

      doc.setFont("helvetica","bold")
      doc.text("Balance Pendiente",28,finalY)
      doc.setFont("helvetica","normal")
      if(tipoPrestamo=='plazo_indefinido'){
        var totalPagado = totalpagado+capital+totalmora+cargosNum-totaldescuento;
        var capitalPendienteNumActual = capitalPendienteNum-capital;
        var interesPendienteNumActual = totalpagado
        doc.text((capitalPendienteNumActual+totalpendiente).toFixed(2),68,finalY,{align: 'right'})

      }else{
        doc.text(balancePendiente.toFixed(2),68,finalY,{align: 'right'})
      }
      }

     finalY = finalY + 6


     if(capital != 0){
      doc.setFont("helvetica","bold")
      doc.text("Capital Pag.",28,finalY)
      doc.setFont("helvetica","normal")
      doc.text(capital.toFixed(2),68,finalY,{align: 'right'})
     }

     if(cargosNum > 0){
      finalY = finalY + 4
      doc.setFont("helvetica","bold")
      doc.text("Cargos",28,finalY)
      doc.setFont("helvetica","normal")
      doc.text(cargosNum.toFixed(2),68,finalY,{align: 'right'})
     }

     finalY= finalY + 4
     doc.setFont("helvetica","bold")
     doc.text("Total Mora",28,finalY)
     doc.setFont("helvetica","normal")
     doc.text(totalmora.toFixed(2),68,finalY,{align: 'right'})

     finalY= finalY + 4
     doc.setFont("helvetica","bold")
     doc.text("Descuento",28,finalY)
     doc.setFont("helvetica","normal")
     doc.text(totaldescuento.toFixed(2),68,finalY,{align: 'right'})

     finalY= finalY + 4
     doc.setFont("helvetica","bold")
     doc.text("Total Pagado",28,finalY)
     doc.setFont("helvetica","normal")
     doc.text((totalpagado+capital+totalmora+cargosNum-totaldescuento).toFixed(2),68,finalY,{align: 'right'})
     
     finalY= finalY + 8
    

//     const canvas = document.createElement("canvas")
  //   JsBarcode(canvas, "1234567890",{
    //    format: 'CODE128',
      //  displayValue: false,
     //})

//     const barcodepng = canvas.toDataURL("image/png")
  //   doc.addImage(barcodepng,'PNG',13, finalY,50,20,{align:"center"}) 

     //doc.setFontSize(5)
     //doc.text("____________________________________________________________________________",1,finalY)
     //doc.setFontSize(10)


     const pdfBlob = doc.output('blob');
      const url = URL.createObjectURL(pdfBlob);
      window.open(url, '_blank');
 
 
}

export function impresionrecibopagopos(nombreempresa,nombrereporte,data,fecha) {
   
   const doc = new jsPDF({
       orientation: "portrait",
       unit: "mm",
       format: [77,355]
    })

    var fontSize = 8
    console.log(data)
    //text width
    doc.addImage(process.env.REACT_APP_SERVIDOR+"/logo"+'/'+localStorage.getItem('parent'),'JPEG',35,10,12,12)

    doc.setFont("helvetica","bold")
    doc.setFontSize(10)
    var xcenter = doc.internal.pageSize.width/2
    doc.text(nombreempresa,xcenter,27,{align:'center'})
    
    doc.setFont("helvetica","bold")
    doc.text(nombrereporte,xcenter,32,{align: 'center'})
   
    
    doc.setFont("helvetica","normal")
    doc.setFontSize(5)
    
    doc.text("____________________________________________________________________________",1,35)
 
    doc.setFontSize(8)
    
    
    
    doc.setFont("helvetica","bold")
    doc.text("Cliente",4,40)
    doc.setFont("helvetica","normal")
    doc.text("Cliente Final",20,40)    
    
    doc.setFont("helvetica","bold")
    doc.text("Fecha",4,44)
    doc.setFont("helvetica","normal")
    doc.text(fecha,20,44)
    
    doc.setFont("helvetica","normal")
    
    const datalist = []
    var c = 0
    var totalsubtotal = 0
    var totalimpuestos = 0
    data.map((result)=>{
          datalist[c] = [result['name'],result['price'],result['qty'],result['total']]
          c++
          totalsubtotal = totalsubtotal + parseFloat(result['total'])
          
       
     })
 
    var finalY = 0
    autoTable(doc,{
       head:[['       Producto','  Precio','Cantidad','    Total']],
       body: datalist,
       startY: 56,
       margin: {left: 0, right:0},
       styles: { fontSize: 8},
       columnStyles: {
           0: {width:100, halign:"center"},
           1: {halign:"center",width:100}, 
           2: {halign:"center",width:100},
           3: {halign:"center",width:100}
       },
       headStyles: {fillColor:"#18586b"},
       alternateRowStyles: {fillColor:"white"},
       didDrawPage: function(data){
           finalY = data.cursor.y
       }
    })

    
    doc.setFontSize(5)
    finalY = finalY + 15
    
    doc.text("____________________________________________________________________________",1,finalY)
    doc.setFontSize(8)

    finalY = finalY + 8


    doc.setFont("helvetica","bold")
    doc.text("Subtotal",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalsubtotal.toFixed(2),72,finalY,{align: 'right'})
    
    finalY= finalY + 4
    doc.setFont("helvetica","bold")
    doc.text("Impuestos",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalimpuestos.toFixed(2),72,finalY,{align: 'right'})
    
    finalY= finalY + 4
    doc.setFont("helvetica","bold")
    doc.text("Total",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalsubtotal.toFixed(2),72,finalY,{align: 'right'})
     
   

//     const canvas = document.createElement("canvas")
 //   JsBarcode(canvas, "1234567890",{
   //    format: 'CODE128',
     //  displayValue: false,
    //})

//     const barcodepng = canvas.toDataURL("image/png")
 //   doc.addImage(barcodepng,'PNG',13, finalY,50,20,{align:"center"}) 

    //doc.setFontSize(5)
    //doc.text("____________________________________________________________________________",1,finalY)
    //doc.setFontSize(10)


    doc.output('dataurlnewwindow')   


}

export function impresionrecibopagoinicial(cliente,nombreempresa,nombrereporte,fecha,monto,producto,data) {
   
   const doc = new jsPDF({
       orientation: "portrait",
       unit: "mm",
       format: [77,355]
    })

    var fontSize = 8
    //text width
    doc.addImage(process.env.REACT_APP_SERVIDOR+"/logo"+'/'+localStorage.getItem('parent'),'JPEG',35,10,12,12)

    doc.setFont("helvetica","bold")
    doc.setFontSize(10)
    var xcenter = doc.internal.pageSize.width/2
    doc.text(nombreempresa,xcenter,27,{align:'center'})
    
    doc.setFont("helvetica","bold")
    doc.text(nombrereporte,xcenter,32,{align: 'center'})

   
    
    doc.setFont("helvetica","normal")
    doc.setFontSize(5)
    
    doc.text("____________________________________________________________________________",1,35)
 
    doc.setFontSize(8)
    
    
    
    doc.setFont("helvetica","bold")
    doc.text("Cliente",4,40)
    doc.setFont("helvetica","normal")
    doc.text(cliente,20,40)    
    
    doc.setFont("helvetica","bold")
    doc.text("Fecha",4,44)
    doc.setFont("helvetica","normal")
    doc.text(fecha,20,44)

    doc.setFont("helvetica","bold")
    doc.text("Producto",4,48)
    doc.setFont("helvetica","normal")
    doc.text(producto,20,48)

    doc.setFont("helvetica","normal")
    
    const datalist = []
    var c = 0
    data.map((result)=>{
        datalist[c] = [result['concepto'],result['total']]
        c++
    })
    var totalsubtotal = monto
    var totalimpuestos = 0
 
    var finalY = 0
    autoTable(doc,{
       head:[['Concepto','Total']],
       body: datalist,
       startY: 56,
       margin: {left: 0, right:0},
       styles: { fontSize: 8},
       columnStyles: {
           0: {width:150, halign:"left", marginLeft: 10},
           1: {halign:"left",width:150}, 
       },
       headStyles: {fillColor:"#18586b", halign:"left",width:150},
       alternateRowStyles: {fillColor:"white"},
       didDrawPage: function(datalist){
           finalY = datalist.cursor.y
       }
    })

    
    doc.setFontSize(5)
    finalY = finalY + 15
    
    doc.text("____________________________________________________________________________",1,finalY)
    doc.setFontSize(8)

    finalY = finalY + 8


    doc.setFont("helvetica","bold")
    doc.text("Subtotal",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalsubtotal,72,finalY,{align: 'right'})
    
    finalY= finalY + 4
    doc.setFont("helvetica","bold")
    doc.text("Impuestos",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalimpuestos.toFixed(2),72,finalY,{align: 'right'})
    
    finalY= finalY + 4
    doc.setFont("helvetica","bold")
    doc.text("Total",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalsubtotal,72,finalY,{align: 'right'})
     
   

//     const canvas = document.createElement("canvas")
 //   JsBarcode(canvas, "1234567890",{
   //    format: 'CODE128',
     //  displayValue: false,
    //})

//     const barcodepng = canvas.toDataURL("image/png")
 //   doc.addImage(barcodepng,'PNG',13, finalY,50,20,{align:"center"}) 

    //doc.setFontSize(5)
    //doc.text("____________________________________________________________________________",1,finalY)
    //doc.setFontSize(10)


    doc.output('dataurlnewwindow')   


}

export function impresionrecibopagocargosprestamo(cliente,nombreempresa,nombrereporte,fecha,monto,noprest,data) {
   
   const doc = new jsPDF({
       orientation: "portrait",
       unit: "mm",
       format: [77,355]
    })

    var fontSize = 8
    //text width
    doc.addImage(process.env.REACT_APP_SERVIDOR+"/logo"+'/'+localStorage.getItem('parent'),'JPEG',35,10,12,12)

    doc.setFont("helvetica","bold")
    doc.setFontSize(10)
    var xcenter = doc.internal.pageSize.width/2
    doc.text(nombreempresa,xcenter,27,{align:'center'})
    
    doc.setFont("helvetica","bold")
    doc.text(nombrereporte,xcenter,32,{align: 'center'})

   
    
    doc.setFont("helvetica","normal")
    doc.setFontSize(5)
    
    doc.text("____________________________________________________________________________",1,35)
 
    doc.setFontSize(8)
    
    
    
    doc.setFont("helvetica","bold")
    doc.text("Cliente",4,40)
    doc.setFont("helvetica","normal")
    doc.text(cliente,20,40)    
    
    doc.setFont("helvetica","bold")
    doc.text("Fecha",4,44)
    doc.setFont("helvetica","normal")
    doc.text(fecha,20,44)

    doc.setFont("helvetica","bold")
    doc.text("Noprest",4,48)
    doc.setFont("helvetica","normal")
    doc.text(noprest,20,48)

    doc.setFont("helvetica","normal")
    
    const datalist = []
    var c = 0
    var totalsubtotal = 0
    var totalimpuestos = 0

    data.map((result)=>{
        datalist[c] = [result['concepto'],result['total']]
        c++
        totalsubtotal = totalsubtotal + parseFloat(result['total'])
    })
 
    var finalY = 0
    autoTable(doc,{
       head:[['Concepto','Total']],
       body: datalist,
       startY: 56,
       margin: {left: 0, right:0},
       styles: { fontSize: 8},
       columnStyles: {
           0: {width:150, halign:"left", marginLeft: 10},
           1: {halign:"left",width:150}, 
       },
       headStyles: {fillColor:"#18586b", halign:"left",width:150},
       alternateRowStyles: {fillColor:"white"},
       didDrawPage: function(datalist){
           finalY = datalist.cursor.y
       }
    })

    
    doc.setFontSize(5)
    finalY = finalY + 15
    
    doc.text("____________________________________________________________________________",1,finalY)
    doc.setFontSize(8)

    finalY = finalY + 8


    doc.setFont("helvetica","bold")
    doc.text("Subtotal",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalsubtotal.toFixed(2),72,finalY,{align: 'right'})
    
    finalY= finalY + 4
    doc.setFont("helvetica","bold")
    doc.text("Impuestos",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalimpuestos.toFixed(2),72,finalY,{align: 'right'})
    
    finalY= finalY + 4
    doc.setFont("helvetica","bold")
    doc.text("Total",30,finalY)
    doc.setFont("helvetica","normal")
    doc.text(totalsubtotal.toFixed(2),72,finalY,{align: 'right'})
     
   

//     const canvas = document.createElement("canvas")
 //   JsBarcode(canvas, "1234567890",{
   //    format: 'CODE128',
     //  displayValue: false,
    //})

//     const barcodepng = canvas.toDataURL("image/png")
 //   doc.addImage(barcodepng,'PNG',13, finalY,50,20,{align:"center"}) 

    //doc.setFontSize(5)
    //doc.text("____________________________________________________________________________",1,finalY)
    //doc.setFontSize(10)


    doc.output('dataurlnewwindow')   


}
export function impresionreciboabonocapital(
    nombreempresa,
    cedula,
    nombres,
    noprest,
    fechaPago,
    montoAbono,
    metodoPago,
    observaciones
) {
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [77, 355]
    });

    const xcenter = doc.internal.pageSize.width / 2;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(nombreempresa || "", xcenter, 27, { align: 'center' });
    doc.text("Recibo de Abono a Capital", xcenter, 32, { align: 'center' });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(5);
    doc.text("____________________________________________________________________________", 1, 35);

    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    doc.text("Cedula", 4, 40);
    doc.setFont("helvetica", "normal");
    doc.text(String(cedula || ""), 20, 40);

    doc.setFont("helvetica", "bold");
    doc.text("Nombres", 4, 44);
    doc.setFont("helvetica", "normal");
    doc.text(String(nombres || ""), 20, 44);

    doc.setFont("helvetica", "bold");
    doc.text("Noprest", 4, 48);
    doc.setFont("helvetica", "normal");
    doc.text(String(noprest || ""), 20, 48);

    doc.setFont("helvetica", "bold");
    doc.text("Fecha", 4, 52);
    doc.setFont("helvetica", "normal");
    let fechaTxt = "";
    if (fechaPago) {
        fechaTxt = String(fechaPago);
    } else {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        fechaTxt = `${day}/${month}/${year}`;
    }
    doc.text(fechaTxt, 20, 52);

    let finalY = 60;
    doc.setFontSize(5);
    doc.text("____________________________________________________________________________", 1, finalY);
    doc.setFontSize(8);

    finalY += 6;
    doc.setFont("helvetica", "bold");
    doc.text("Concepto", 4, finalY);
    doc.setFont("helvetica", "normal");
    doc.text("Abono a capital", 28, finalY);

    finalY += 6;
    doc.setFont("helvetica", "bold");
    doc.text("Monto Abonado", 4, finalY);
    doc.setFont("helvetica", "normal");
    const montoNum = parseFloat(montoAbono) || 0;
    doc.text(montoNum.toFixed(2), 72, finalY, { align: 'right' });

    if (Array.isArray(metodoPago) && metodoPago.length > 0) {
        finalY += 6;
        doc.setFont("helvetica", "bold");
        doc.text("Metodos de Pago", 4, finalY);
        metodoPago.forEach((m) => {
            finalY += 4;
            doc.setFont("helvetica", "normal");
            const label = String(m.method || "");
            const amount = parseFloat(m.amount) || 0;
            doc.text(label, 8, finalY);
            doc.text(amount.toFixed(2), 72, finalY, { align: 'right' });
            if (m.reference) {
                finalY += 4;
                doc.setFontSize(7);
                doc.text(`Ref: ${m.reference}`, 12, finalY);
                doc.setFontSize(8);
            }
        });
    }

    if (observaciones) {
        finalY += 6;
        doc.setFont("helvetica", "bold");
        doc.text("Observaciones", 4, finalY);
        finalY += 4;
        doc.setFont("helvetica", "normal");
        const lines = doc.splitTextToSize(String(observaciones), 70);
        doc.text(lines, 4, finalY);
        finalY += lines.length * 4;
    }

    finalY += 4;
    doc.setFontSize(5);
    doc.text("____________________________________________________________________________", 1, finalY);
    doc.setFontSize(8);

    finalY += 6;
    doc.setFont("helvetica", "bold");
    doc.text("Total Pagado", 28, finalY);
    doc.setFont("helvetica", "normal");
    doc.text(montoNum.toFixed(2), 72, finalY, { align: 'right' });

    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, '_blank');
}
